// @ts-nocheck
import * as Types from '@src/types/graphql-types';

import gql from 'graphql-tag';
import * as React from 'react';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactComponents from '@apollo/react-components';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
export type QuoteDetailQueryVariables = Types.Exact<{
  quoteIdentifier: Types.Scalars['String'];
  isConfirmation: Types.Scalars['Boolean'];
  sysId?: Types.InputMaybe<Types.Scalars['String']>;
  sharedToken?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type QuoteDetailQuery = { __typename?: 'Query', quoteDetail: { __typename?: 'QuoteDetailPayload', quote: { __typename?: 'QuoteDetails', quoteId?: string | null, quoteUUID?: string | null, quoteType?: string | null, documentType?: string | null, orderedBy: string, canReturnOrder: boolean, createdDate: number, expirationDate: number, eligibleForBuyItNow?: boolean | null, poNumber?: string | null, requisitionNumber?: string | null, packingSlipNote?: string | null, message: string, soldTo?: string | null, subtotal: number, total: number, currency: string, status: string, isRequestNewQuoteEnabled: boolean, isConvertQuoteToOrderEnabled: boolean, isReorderEnabled: boolean, customerServiceNote?: string | null, salesTax?: number | null, dutyTotal?: number | null, eurVolatileMassCharge?: number | null, sfdcReference?: string | null, ice?: number | null, tariffSurcharge?: number | null, pkg?: number | null, alcTax?: number | null, transHandlingCharge?: number | null, electricalFee?: number | null, complianceFee?: number | null, shippingTransportation?: number | null, hasQuotePriceItem: boolean, transSurchargeMessage?: string | null, quoteName?: string | null, billingInfo: { __typename?: 'OrderContactInfo', city?: string | null, countryName?: string | null, email?: string | null, buildingRoom?: string | null, attentionTo?: string | null, organizationName?: string | null, phone?: string | null, postalCode?: string | null, stateName?: string | null, street?: string | null, street3?: string | null, street4?: string | null, department?: string | null, phoneNumber2?: string | null }, contactInfo: { __typename?: 'OrderContactDetail', orderedBy: string, phone?: string | null, email?: string | null, faxNumber?: string | null, ccEmail?: string | null, phoneNumber1?: string | null, phoneNumber2?: string | null }, shippingInfo: { __typename?: 'OrderContactInfo', city?: string | null, countryName?: string | null, email?: string | null, buildingRoom?: string | null, attentionTo?: string | null, organizationName?: string | null, phone?: string | null, postalCode?: string | null, stateName?: string | null, street?: string | null, street3?: string | null, street4?: string | null, department?: string | null, phoneNumber2?: string | null }, quoteItems: Array<{ __typename?: 'QuoteItem', lineNumber?: string | null, materialNumber: string, product?: string | null, brandId?: string | null, description?: string | null, qty?: number | null, originalQty?: number | null, remainingQty?: number | null, reference?: string | null, itemPrice: number, linePrice: number, pricePerUnit: number, listPrice?: number | null, yourPrice?: number | null, isQuotePriceItem?: boolean | null, currency: string, listPriceCurrency?: string | null, promoCode?: string | null, productNote?: string | null, complianceMessages?: Array<string> | null, type: Types.CartItemType, configurationId?: string | null, productType?: string | null, hidePriceMessageKey?: string | null, status?: string | null, productDetails?: { __typename?: 'Product', productNumber: string, name: string, description?: string | null, sdsLanguages: Array<string | null>, sdsPnoKey: string, brand: { __typename?: 'Brand', name?: string | null, key: string }, images: Array<{ __typename?: 'CatalogImage', altText?: string | null, smallUrl: string, mediumUrl: string, largeUrl: string }>, specificationSheet: { __typename?: 'SpecificationSheet', url?: string | null } } | null, additionalInfo?: { __typename?: 'OrderAdditionalInfo', carrierRestriction?: string | null, unNumber?: string | null, tariff?: string | null, casNumber?: string | null, jfcCode?: string | null, pdcCode?: string | null } | null, kitItems: Array<{ __typename?: 'CartKitItem', materialNumber: string, materialDescription: string, listPrice: number, netPrice: number, price: number, quantity: number }>, materialInfo: { __typename?: 'Material', id: string, description?: string | null, productKey?: string | null, product: string, name?: string | null, number: string, brand: { __typename?: 'Brand', key: string, name?: string | null, color?: string | null, logo?: { __typename?: 'CatalogImage', mediumUrl: string } | null }, image: { __typename?: 'CatalogImage', smallUrl: string, mediumUrl: string, largeUrl: string } }, configuration: Array<{ __typename?: 'ProductConfiguration', name?: string | null, value?: string | null, sapCharc?: string | null }>, scheduleLines: Array<{ __typename?: 'OrderItemScheduleLine', lotNumber: Array<{ __typename?: 'OrderItemLotNumber', quantity?: number | null, batch: string }> }>, availabilityMessages?: Array<{ __typename?: 'OrderItemAvailabilityMessages', key: string, quantity?: number | null, date?: number | null, plantLoc?: string | null } | null> | null }> } } };

export type QuoteDetailsFragment = { __typename?: 'QuoteDetails', quoteId?: string | null, quoteUUID?: string | null, quoteType?: string | null, documentType?: string | null, orderedBy: string, canReturnOrder: boolean, createdDate: number, expirationDate: number, eligibleForBuyItNow?: boolean | null, poNumber?: string | null, requisitionNumber?: string | null, packingSlipNote?: string | null, message: string, soldTo?: string | null, subtotal: number, total: number, currency: string, status: string, isRequestNewQuoteEnabled: boolean, isConvertQuoteToOrderEnabled: boolean, isReorderEnabled: boolean, customerServiceNote?: string | null, salesTax?: number | null, dutyTotal?: number | null, eurVolatileMassCharge?: number | null, sfdcReference?: string | null, ice?: number | null, tariffSurcharge?: number | null, pkg?: number | null, alcTax?: number | null, transHandlingCharge?: number | null, electricalFee?: number | null, complianceFee?: number | null, shippingTransportation?: number | null, hasQuotePriceItem: boolean, transSurchargeMessage?: string | null, quoteName?: string | null, billingInfo: { __typename?: 'OrderContactInfo', city?: string | null, countryName?: string | null, email?: string | null, buildingRoom?: string | null, attentionTo?: string | null, organizationName?: string | null, phone?: string | null, postalCode?: string | null, stateName?: string | null, street?: string | null, street3?: string | null, street4?: string | null, department?: string | null, phoneNumber2?: string | null }, contactInfo: { __typename?: 'OrderContactDetail', orderedBy: string, phone?: string | null, email?: string | null, faxNumber?: string | null, ccEmail?: string | null, phoneNumber1?: string | null, phoneNumber2?: string | null }, shippingInfo: { __typename?: 'OrderContactInfo', city?: string | null, countryName?: string | null, email?: string | null, buildingRoom?: string | null, attentionTo?: string | null, organizationName?: string | null, phone?: string | null, postalCode?: string | null, stateName?: string | null, street?: string | null, street3?: string | null, street4?: string | null, department?: string | null, phoneNumber2?: string | null }, quoteItems: Array<{ __typename?: 'QuoteItem', lineNumber?: string | null, materialNumber: string, product?: string | null, brandId?: string | null, description?: string | null, qty?: number | null, originalQty?: number | null, remainingQty?: number | null, reference?: string | null, itemPrice: number, linePrice: number, pricePerUnit: number, listPrice?: number | null, yourPrice?: number | null, isQuotePriceItem?: boolean | null, currency: string, listPriceCurrency?: string | null, promoCode?: string | null, productNote?: string | null, complianceMessages?: Array<string> | null, type: Types.CartItemType, configurationId?: string | null, productType?: string | null, hidePriceMessageKey?: string | null, status?: string | null, productDetails?: { __typename?: 'Product', productNumber: string, name: string, description?: string | null, sdsLanguages: Array<string | null>, sdsPnoKey: string, brand: { __typename?: 'Brand', name?: string | null, key: string }, images: Array<{ __typename?: 'CatalogImage', altText?: string | null, smallUrl: string, mediumUrl: string, largeUrl: string }>, specificationSheet: { __typename?: 'SpecificationSheet', url?: string | null } } | null, additionalInfo?: { __typename?: 'OrderAdditionalInfo', carrierRestriction?: string | null, unNumber?: string | null, tariff?: string | null, casNumber?: string | null, jfcCode?: string | null, pdcCode?: string | null } | null, kitItems: Array<{ __typename?: 'CartKitItem', materialNumber: string, materialDescription: string, listPrice: number, netPrice: number, price: number, quantity: number }>, materialInfo: { __typename?: 'Material', id: string, description?: string | null, productKey?: string | null, product: string, name?: string | null, number: string, brand: { __typename?: 'Brand', key: string, name?: string | null, color?: string | null, logo?: { __typename?: 'CatalogImage', mediumUrl: string } | null }, image: { __typename?: 'CatalogImage', smallUrl: string, mediumUrl: string, largeUrl: string } }, configuration: Array<{ __typename?: 'ProductConfiguration', name?: string | null, value?: string | null, sapCharc?: string | null }>, scheduleLines: Array<{ __typename?: 'OrderItemScheduleLine', lotNumber: Array<{ __typename?: 'OrderItemLotNumber', quantity?: number | null, batch: string }> }>, availabilityMessages?: Array<{ __typename?: 'OrderItemAvailabilityMessages', key: string, quantity?: number | null, date?: number | null, plantLoc?: string | null } | null> | null }> };

export type QuoteContactInfoFragment = { __typename?: 'OrderContactInfo', city?: string | null, countryName?: string | null, email?: string | null, buildingRoom?: string | null, attentionTo?: string | null, organizationName?: string | null, phone?: string | null, postalCode?: string | null, stateName?: string | null, street?: string | null, street3?: string | null, street4?: string | null, department?: string | null, phoneNumber2?: string | null };

export type QuoteItemFragment = { __typename?: 'QuoteItem', lineNumber?: string | null, materialNumber: string, product?: string | null, brandId?: string | null, description?: string | null, qty?: number | null, originalQty?: number | null, remainingQty?: number | null, reference?: string | null, itemPrice: number, linePrice: number, pricePerUnit: number, listPrice?: number | null, yourPrice?: number | null, isQuotePriceItem?: boolean | null, currency: string, listPriceCurrency?: string | null, promoCode?: string | null, productNote?: string | null, complianceMessages?: Array<string> | null, type: Types.CartItemType, configurationId?: string | null, productType?: string | null, hidePriceMessageKey?: string | null, status?: string | null, productDetails?: { __typename?: 'Product', productNumber: string, name: string, description?: string | null, sdsLanguages: Array<string | null>, sdsPnoKey: string, brand: { __typename?: 'Brand', name?: string | null, key: string }, images: Array<{ __typename?: 'CatalogImage', altText?: string | null, smallUrl: string, mediumUrl: string, largeUrl: string }>, specificationSheet: { __typename?: 'SpecificationSheet', url?: string | null } } | null, additionalInfo?: { __typename?: 'OrderAdditionalInfo', carrierRestriction?: string | null, unNumber?: string | null, tariff?: string | null, casNumber?: string | null, jfcCode?: string | null, pdcCode?: string | null } | null, kitItems: Array<{ __typename?: 'CartKitItem', materialNumber: string, materialDescription: string, listPrice: number, netPrice: number, price: number, quantity: number }>, materialInfo: { __typename?: 'Material', id: string, description?: string | null, productKey?: string | null, product: string, name?: string | null, number: string, brand: { __typename?: 'Brand', key: string, name?: string | null, color?: string | null, logo?: { __typename?: 'CatalogImage', mediumUrl: string } | null }, image: { __typename?: 'CatalogImage', smallUrl: string, mediumUrl: string, largeUrl: string } }, configuration: Array<{ __typename?: 'ProductConfiguration', name?: string | null, value?: string | null, sapCharc?: string | null }>, scheduleLines: Array<{ __typename?: 'OrderItemScheduleLine', lotNumber: Array<{ __typename?: 'OrderItemLotNumber', quantity?: number | null, batch: string }> }>, availabilityMessages?: Array<{ __typename?: 'OrderItemAvailabilityMessages', key: string, quantity?: number | null, date?: number | null, plantLoc?: string | null } | null> | null };

export const QuoteContactInfoFragmentDoc = gql`
    fragment QuoteContactInfo on OrderContactInfo {
  city
  countryName
  email
  buildingRoom
  attentionTo
  organizationName
  phone
  postalCode
  stateName
  street
  street3
  street4
  department
  phoneNumber2
}
    `;
export const QuoteItemFragmentDoc = gql`
    fragment QuoteItem on QuoteItem {
  lineNumber
  materialNumber
  product
  brandId
  productDetails {
    productNumber
    name
    description
    brand {
      name
      key
    }
    images {
      altText
      smallUrl
      mediumUrl
      largeUrl
    }
    sdsLanguages
    specificationSheet {
      url
    }
    sdsPnoKey
  }
  description
  qty
  originalQty
  remainingQty
  reference
  itemPrice
  linePrice
  pricePerUnit
  listPrice
  yourPrice
  isQuotePriceItem
  currency
  listPriceCurrency
  promoCode
  productNote
  additionalInfo {
    carrierRestriction
    unNumber
    tariff
    casNumber
    jfcCode
    pdcCode
  }
  complianceMessages
  kitItems {
    materialNumber
    materialDescription
    listPrice
    netPrice
    price
    quantity
  }
  materialInfo {
    id
    description
    brand {
      key
      name
      color
      logo {
        mediumUrl
      }
    }
    productKey
    product
    image {
      smallUrl
      mediumUrl
      largeUrl
    }
    name
    number
  }
  type
  configurationId
  productType
  configuration {
    name
    value
    sapCharc
  }
  scheduleLines {
    lotNumber {
      quantity
      batch
    }
  }
  availabilityMessages {
    key
    quantity
    date
    plantLoc
  }
  hidePriceMessageKey
  status
}
    `;
export const QuoteDetailsFragmentDoc = gql`
    fragment QuoteDetails on QuoteDetails {
  quoteId
  quoteUUID
  quoteType
  documentType
  orderedBy
  canReturnOrder
  createdDate
  expirationDate
  eligibleForBuyItNow
  poNumber
  requisitionNumber
  packingSlipNote
  message
  soldTo
  billingInfo {
    ...QuoteContactInfo
  }
  contactInfo {
    orderedBy
    phone
    email
    faxNumber
    ccEmail
    phoneNumber1
    phoneNumber2
  }
  shippingInfo {
    ...QuoteContactInfo
  }
  quoteItems {
    ...QuoteItem
  }
  subtotal
  total
  currency
  status
  isRequestNewQuoteEnabled
  isConvertQuoteToOrderEnabled
  isReorderEnabled
  customerServiceNote
  salesTax
  dutyTotal
  eurVolatileMassCharge
  sfdcReference
  ice
  tariffSurcharge
  pkg
  alcTax
  transHandlingCharge
  electricalFee
  complianceFee
  shippingTransportation
  hasQuotePriceItem
  transSurchargeMessage
  quoteName
}
    ${QuoteContactInfoFragmentDoc}
${QuoteItemFragmentDoc}`;
export const QuoteDetailDocument = gql`
    query QuoteDetail($quoteIdentifier: String!, $isConfirmation: Boolean!, $sysId: String, $sharedToken: String) {
  quoteDetail(
    input: {quoteIdentifier: $quoteIdentifier, isConfirmation: $isConfirmation, sysId: $sysId, sharedToken: $sharedToken}
  ) {
    quote {
      ...QuoteDetails
    }
  }
}
    ${QuoteDetailsFragmentDoc}`;
export type QuoteDetailComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<QuoteDetailQuery, QuoteDetailQueryVariables>, 'query'> & ({ variables: QuoteDetailQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const QuoteDetailComponent = (props: QuoteDetailComponentProps) => (
      <ApolloReactComponents.Query<QuoteDetailQuery, QuoteDetailQueryVariables> query={QuoteDetailDocument} {...props} />
    );
    

/**
 * __useQuoteDetailQuery__
 *
 * To run a query within a React component, call `useQuoteDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteDetailQuery({
 *   variables: {
 *      quoteIdentifier: // value for 'quoteIdentifier'
 *      isConfirmation: // value for 'isConfirmation'
 *      sysId: // value for 'sysId'
 *      sharedToken: // value for 'sharedToken'
 *   },
 * });
 */
export function useQuoteDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<QuoteDetailQuery, QuoteDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<QuoteDetailQuery, QuoteDetailQueryVariables>(QuoteDetailDocument, options);
      }
export function useQuoteDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<QuoteDetailQuery, QuoteDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<QuoteDetailQuery, QuoteDetailQueryVariables>(QuoteDetailDocument, options);
        }
export type QuoteDetailQueryHookResult = ReturnType<typeof useQuoteDetailQuery>;
export type QuoteDetailLazyQueryHookResult = ReturnType<typeof useQuoteDetailLazyQuery>;
export type QuoteDetailQueryResult = ApolloReactCommon.QueryResult<QuoteDetailQuery, QuoteDetailQueryVariables>;